Accounts = require 'app/common/lib/accounts'
Auth = require 'app/scripts/db/auth'
Browser = require '@trello/browser'
NewLocaleBannerView = require 'app/scripts/views/header/new-locale-banner-view'
PostRender = require 'app/scripts/views/lib/post-render'
SetPasswordBannerView = undefined
{ track } = require '@trello/analytics'
Util = require 'app/scripts/lib/util'
{ Storage } = require '@trello/storage'
_ = require 'underscore'
$ = require 'jquery'
moment = require 'moment'
templates = require 'app/scripts/views/internal/templates'
locales = require('@trello/locale').supportedLocales
getExperiment = require 'app/scripts/lib/experiments/simple-test'
gammaHeaderBranding = require './header-branding'

{ featureFlagClient } = require '@trello/feature-flag-client'
{ isBrowserSupported, isDesktop } = require '@trello/browser'

needBackupCodes = (member) ->
  twoFactorPrefs = member.getPref('twoFactor')
  twoFactorPrefs?.enabled && twoFactorPrefs.needsNewBackups

getOverdueOrganization = (member) ->
  bcOrgs = member.organizationList.filter (org) ->
    org.isPremium() &&
    org.ownedByMember(member) &&
    !org.paysWithPurchaseOrder()

  for bcOrg in bcOrgs
    paidAccount = bcOrg.get('paidAccount')
    billingDate = new Date(paidAccount.billingDates?[paidAccount.products?[0]])
    bannerName = "OverdueBanner-#{bcOrg.id}-#{billingDate.getTime()}"
    if Accounts.isProblem(paidAccount.standing) &&
        paidAccount.needsCreditCardUpdate &&
        !member.isDismissed(bannerName)
      return bcOrg

showSeatCapBannerForEntity = (member, entity, idEnterprise, maxMembers, available, headerCache, topLevelView) =>
  # Dependency required at call site to avoid import cycles, do not lift to top of module
  EnterpriseLicenseBannerView = require 'app/scripts/views/header/enterprise-license-banner-view'
  threshold = Math.min(Math.ceil(maxMembers * 0.05), 20)
  if available <= threshold
    data = {
      displayName: entity.get('displayName'),
      idEnterprise,
      seats: { max: maxMembers, available }
      cid: entity.cid
    }
    $('#banners').prepend(topLevelView(EnterpriseLicenseBannerView, data, modelCache: headerCache).render().el)

    #record that the banner was shown for this user, so we check that we showed it
    member.recordEnterpriseBannerShownFor(idEnterprise)

showSeatCapBanner = (member, headerCache, topLevelView) =>
  # get the enterprises this member is the admin of, if any and hasn't had
  # its banner shown recently
  enterprises = member.enterpriseList.filter (e) ->
    member.isEnterpriseAdminOf(e) &&
    member.shouldShowEnterpriseBannerFor e.id

  # load license data asynchronously and display the banner if needed
  enterprises.forEach (enterprise) ->
    enterprise.loadMaxMembers().then =>
      #record that we checked if we needed to show the banner, so we don't check again right away
      member.recordEnterpriseBannerCheckedFor(enterprise.id)

      # don't try to load the license data if max members is not set.
      # child enterprises do not have max members set, so this also
      # excludes showing the banner for child enterprises
      return unless maxMembers = enterprise.getPref('maxMembers')
      enterprise.loadLicenses().then =>
        available = enterprise.getAvailableLicenses()
        showSeatCapBannerForEntity(member, enterprise, enterprise.id, maxMembers, available, headerCache, topLevelView)

  # find bpco orgs this member is the admin of and hasn't already had
  # its banner shown recently. if there are more than one related bcpo
  # org, only grab one
  bcpoOrgs = member.organizationList.models.filter (org) ->
      org.paysWithPurchaseOrder() &&
      org.isBusinessClass() &&
      org.ownedByMember(member) &&
      member.shouldShowEnterpriseBannerFor org.get('idEnterprise')
  bcpoOrgs = _.uniq bcpoOrgs, (org) -> org.get('idEnterprise')

  # load license data asynchronously and display the banner if needed
  bcpoOrgs.forEach (org) ->
    idEnterprise = org.get('idEnterprise')
    org.loadLicenses().then =>
      max = org.get('maximumLicenseCount')
      available = org.get('availableLicenseCount')
      #record that we checked if we needed to show the banner, so we don't check again right away
      member.recordEnterpriseBannerCheckedFor(idEnterprise)
      showSeatCapBannerForEntity(member, org, idEnterprise, max, available, headerCache, topLevelView)

showEnterpriseDeprovisioningBannerForEntity = (member, entity, idEnterprise, paidAccount, headerCache, topLevelView) =>
  # Dependency required at call site to avoid import cycles, do not lift to top of module
  EnterpriseDeprovisioningBannerView = require 'app/scripts/views/header/enterprise-deprovisioning-banner-view'
  data = {
    displayName: entity.get('displayName'),
    idEnterprise,
    enterpriseStanding: paidAccount.enterpriseStanding,
    pendingDeprovision: paidAccount.pendingDeprovision,
    cid: entity.cid
  }
  $('#banners').prepend(topLevelView(EnterpriseDeprovisioningBannerView, data, modelCache: headerCache).render().el)

  #record that the banner was shown for this user, so we don't show it again right away
  member.recordEnterpriseDeprovisioningBannerShownFor(idEnterprise)

showEnterpriseDeprovisioningBanner = (member, headerCache, topLevelView) =>
  # get the enterprises this member administers that we haven't displayed the
  # de-provisioning banner for recently
  enterprises = member.enterpriseList.filter (e) ->
    member.isEnterpriseAdminOf(e) &&
    member.shouldShowEnterpriseDeprovisioningBannerFor e.id

  # load billing data asynchronously and display the banner if needed
  enterprises.forEach (enterprise) ->
    #record that we checked if we needed to show the banner, so we don't check again right away
    member.recordEnterpriseDeprovisioningBannerCheckedFor(enterprise.id)
    enterprise.getPaidAccount().then (paidAccount) =>
      if paidAccount.enterpriseStanding > 0
        showEnterpriseDeprovisioningBannerForEntity(member, enterprise, enterprise.id, paidAccount, headerCache, topLevelView)

  # find bpco orgs this member administers that we haven't displayed the
  # de-provisioning banner for recently.
  bcpoOrgs = member.organizationList.models.filter (org) ->
      org.paysWithPurchaseOrder() &&
      org.isBusinessClass() &&
      org.ownedByMember(member) &&
      member.shouldShowEnterpriseDeprovisioningBannerFor org.get('idEnterprise')
  bcpoOrgs = _.uniq bcpoOrgs, (org) -> org.get('idEnterprise')

  # load billing data asynchronously and display the banner if needed
  bcpoOrgs.forEach (org) ->
    idEnterprise = org.get('idEnterprise')
    #record that we checked if we needed to show the banner, so we don't check again right away
    member.recordEnterpriseDeprovisioningBannerCheckedFor(idEnterprise)
    org.getPaidAccount().then (paidAccount) =>
      if paidAccount.enterpriseStanding > 0
        showEnterpriseDeprovisioningBannerForEntity(member, org, idEnterprise, paidAccount, headerCache, topLevelView)

showEnterpriseNotificationBanner = (member, headerCache, topLevelView) ->
  EnterpriseNotificationBannerView = require 'app/scripts/views/header/enterprise-notification-banner-view'
  member.enterpriseList.forEach (enterprise) ->
    notification = enterprise.get('prefs')?.notifications?.banner
    if notification &&
      !Auth.me().isDismissed("enterprise-notification-banner-#{ enterprise.get('id') }")
        data = {
          id: enterprise.get('id')
          displayName: enterprise.get('displayName')
          message: enterprise.get('prefs')?.notifications?.banner
        }
        $('#header').after(topLevelView(EnterpriseNotificationBannerView, data, modelCache: headerCache).render().el)

module.exports =
  renderBannerContent: (selector) ->
    # Dependency required at call site to avoid import cycles, do not lift to top of module
    BrowserWillBeUnsupportedView = require 'app/scripts/views/header/browser-will-be-unsupported-view'
    # Dependency required at call site to avoid import cycles, do not lift to top of module
    InvitedBannerView = require 'app/scripts/views/header/invited-banner-view'
    # Dependency required at call site to avoid import cycles, do not lift to top of module
    ModelCache = require 'app/scripts/db/model-cache'
    # Dependency required at call site to avoid import cycles, do not lift to top of module
    AccountTransferRequiredBannerView = require 'app/scripts/views/header/account-transfer-required-banner-view'
    # Dependency required at call site to avoid import cycles, do not lift to top of module
    ConfirmEmailBannerView = require 'app/scripts/views/header/confirm-email-banner-view'
    # Dependency required at call site to avoid import cycles, do not lift to top of module
    DowngradePeriodBannerView = require 'app/scripts/views/board-limits/downgrade-period-banner-view'
    # Dependency required at call site to avoid import cycles, do not lift to top of module
    LoggedInPublicBoardBannerView = require 'app/scripts/views/header/logged-in-public-board-banner-view'
    # Dependency required at call site to avoid import cycles, do not lift to top of module
    OverdueBannerView = require 'app/scripts/views/header/overdue-banner-view'
    # Dependency required at call site to avoid import cycles, do not lift to top of module
    PublicBoardBannerView = require 'app/scripts/views/header/public-board-banner-view'
    # Dependency required at call site to avoid import cycles, do not lift to top of module
    SetPasswordBannerView = require 'app/scripts/views/header/set-password-banner-view'
    # Dependency required at call site to avoid import cycles, do not lift to top of module
    TwoFactorBackupsBannerView = require 'app/scripts/views/header/two-factor-backups-banner-view'
    # Dependency required at call site to avoid import cycles, do not lift to top of module
    TemplateBannerView = require 'app/scripts/views/header/template-banner-view'
    DomainFreeTeamLimitWarningBanner = require 'app/scripts/views/header/domain-free-team-limit-warning-banner'
    DomainFreeTeamLimitRestrictedBanner = require 'app/scripts/views/header/domain-free-team-limit-restricted-banner'
    PersonalBoardsOwnershipBanner = require 'app/scripts/views/header/personal-boards-ownership-banner-view'

    me = Auth.me()
    headerCache = ModelCache
    container = $('#banners')

    bannerLocales =
    _.chain(locales)
      .pluck('code')
      .filter((locale) -> locale.indexOf('en') != 0)
      .value()

    # See if we need to display a "your browser is old" message
    showUnsupportedBanner = !isBrowserSupported() && !isDesktop()

    if showUnsupportedBanner
      container.append(@topLevelView(BrowserWillBeUnsupportedView, me, modelCache: headerCache).render().el)

    # See if there are any important messages we'd like to convey to the user
    if @currentModel.get()? && Util.hasValidInviteTokenFor(@currentModel.get())
      opts = { modelCache: @getCurrentModelCache() }
      if @onAnyBoardView()
        opts.idBoard = @currentModel.get().id
      else if @onAnyOrganizationView()
        opts.idOrganization = @currentModel.get().id
      opts.idMemberAdder = Util.inviteTokenFor(@currentModel.get().id).split('-')[1]
      container.append(@topLevelView(InvitedBannerView, me, opts, @currentModel.get().id).render().el)
        .toggleClass('personalized-invite', !Auth.isLoggedIn())
    else
      if Auth.isLoggedIn()
        if @onAnyBoardView()
          # Show template banner even if another banner is showing but defer to
          # view for watching if board is a template, in the case where a board
          # is converted into a template.
          templateBanner = @topLevelView(TemplateBannerView, @currentModel.get(), modelCache: @getCurrentModelCache()).render()
          container.append(templateBanner.el)

          # Show logged in public board banner even if another banner is showing,
          # but defer to view for watching if board is public. This handles the case
          # when a board is private but becomes public.
          publicBoardBanner = @topLevelView(LoggedInPublicBoardBannerView, @currentModel.get(), modelCache: @getCurrentModelCache()).render()
          container.append(publicBoardBanner.el)

          # Show the downgrade banner on any board view, regardless of template or visibility
          downgradeBanner = @topLevelView(DowngradePeriodBannerView, @currentModel.get(), modelCache: @getCurrentModelCache()).render()
          container.append(downgradeBanner.el)
        if !Auth.confirmed()
          container.append(@topLevelView(ConfirmEmailBannerView, me, modelCache: headerCache).render().el)
        else if !Auth.canLogIn()
          container.append(@topLevelView(SetPasswordBannerView, me, modelCache: headerCache).render().el)
        else if ((enterprise = Auth.me().enterpriseWithRequiredConversion()) && !me.isAccountTransferBannerDismissed())
          opts =
            modelCache: headerCache
            locale: locale
            enterprise: enterprise
          container.append(@topLevelView(AccountTransferRequiredBannerView, me, opts).render().el)
        else if (
          (enterprise = Auth.me().get('enterpriseToExplicitlyOwnBoards')) &&
          !_.isEmpty(enterprise) &&
          !me.isPersonalBoardOwnershipBannerDismissed()
        )
          container.append(@topLevelView(
            PersonalBoardsOwnershipBanner,
            me,
            {
              enterpriseName: enterprise.name,
              idEnterprise: enterprise.id,
              ownDate: enterprise.ownDate,
            },
          ).render().el)
        else if (featureFlagClient.get('fv.domain-level-free-team-restricted', false) && !me.isDismissed('fv.domain-level-free-team-restricted-banner'))
          container.append(@topLevelView(DomainFreeTeamLimitRestrictedBanner, me, opts).render().el)
        else if (featureFlagClient.get('fv.domain-level-free-team-warning', false) && !me.isDismissed('fv.domain-level-free-team-warning-banner'))
          container.append(@topLevelView(DomainFreeTeamLimitWarningBanner, me, opts).render().el)
        else if (org = getOverdueOrganization(Auth.me()))
          container.append(@topLevelView(OverdueBannerView, org, modelCache: headerCache).render().el)
        else if needBackupCodes(Auth.me())
          container.append(@topLevelView(TwoFactorBackupsBannerView, me, modelCache: headerCache).render().el)
        else if (locale = _.find(bannerLocales, (locale) -> Auth.me().shouldShowNewLanguageBannerFor(locale)))
          container.append(@topLevelView(NewLocaleBannerView, me, { modelCache: headerCache, locale: locale }).render().el)

        # always try to add the seat cap banner, even if another banner is showing
        showSeatCapBanner(Auth.me(), headerCache, @topLevelView.bind(@))

        # always try to add the enterprise deprovisioning banner, even if another banner is showing
        showEnterpriseDeprovisioningBanner(Auth.me(), headerCache, @topLevelView.bind(@))

        # always show enterprise notification banner, even if other banners are showing
        showEnterpriseNotificationBanner(Auth.me(), headerCache, @topLevelView.bind(@))
      else
        if @onAnyBoardView() && @currentModel.get().isPublic()
          if @currentModel.get().isTemplate()
            container.append(@topLevelView(TemplateBannerView, @currentModel.get(), modelCache: @getCurrentModelCache()).render().el)
          else
            container.append(@topLevelView(PublicBoardBannerView, @currentModel.get(), modelCache: @getCurrentModelCache()).render().el)

  headerBranding: gammaHeaderBranding.headerBranding

  showHeader: (opts = {}) ->
    @headerBranding(opts)
    this.renderBannerContent()

    return
